'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; // Modules




// Components


// Helpers

// Constants

// Styles
var _react = require('react');var _react2 = _interopRequireDefault(_react);var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);var _reduxForm = require('redux-form');var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);var _CompanyField = require('./CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);var _index = require('../../index');var _reduxFormValidators = require('../../../helpers/reduxFormValidators');var _constants = require('../../../constants');var _CompanyContactUs = require('./CompanyContactUs.scss');var styles = _interopRequireWildcard(_CompanyContactUs);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CompanyContactUs = function CompanyContactUs(props) {
  var translate = props.translate('companyPage', 'contactsForm');
  var renderTextArea = function renderTextArea(fieldProps) {var
    input = fieldProps.input,meta = fieldProps.meta,name = fieldProps.name,placeholder = fieldProps.placeholder;
    return (
      _react2.default.createElement(_index.OMTextArea, _extends({
        name: name,
        placeholder: placeholder },
      input, {
        isInvalid: meta.touched && meta.error && !meta.active })));


  };

  var handleSubmit = function handleSubmit(evt) {
    props.handleSubmit(props.onSubmit)(evt);
    return true;
  };

  var fetchReCaptchaToken = function fetchReCaptchaToken(evt) {
    props.fetchReCaptchaToken(evt);
    handleSubmit(evt);
  };

  return (
    _react2.default.createElement('div', { id: props.id, className: (0, _classnames2.default)('company-contact-us', styles.companyContactUs, props.className) },
      _react2.default.createElement('div', { className: styles.title }, translate('contactWith'), '\xA0', props.companyName || ''),

      _react2.default.createElement('div', { className: styles.wrapForm },
        _react2.default.createElement('form', { onSubmit: props.handleSubmit, noValidate: 'noValidate' },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'name',
            component: _CompanyField2.default,
            type: 'text',
            placeholder: translate('name').toString() + '*',
            validate: [_reduxFormValidators.required],
            translateForError: props.translate('errorFieldMessages'),
            isRtl: props.isRtl }),


          _react2.default.createElement(_reduxForm.Field, {
            name: 'phone_number',
            component: _CompanyField2.default,
            type: 'text',
            normalize: function normalize(value) {return value.replace(/[\D]/g, '');},
            placeholder: translate('phone').toString() + '*',
            validate: [_reduxFormValidators.required, _reduxFormValidators.phoneNumber],
            translateForError: props.translate('errorFieldMessages'),
            isRtl: props.isRtl }),


          _react2.default.createElement(_reduxForm.Field, {
            name: 'email',
            component: _CompanyField2.default,
            type: 'email',
            placeholder: translate('email').toString(),
            validate: [_reduxFormValidators.notRequiredEmail],
            translateForError: props.translate('errorFieldMessages'),
            isRtl: props.isRtl }),


          _react2.default.createElement(_reduxForm.Field, {
            name: 'message',
            component: 'textarea',
            placeholder: translate('message') + '*',
            validate: [_reduxFormValidators.required]
            // translateForError={props.translate('errorFieldMessages')}
            // isRtl={props.isRtl}
          }),

          !!props.formError &&
          _react2.default.createElement('p', { className: 'message' },
            translate('submit_fail_message'), ' ', _react2.default.createElement('a', { href: 'mailto:' + _constants.supportEmail }, _constants.supportEmail)),



          _react2.default.createElement(_index.GoogleReCaptcha, {
              locale: props.locale,
              fetchToken: fetchReCaptchaToken,
              doReset: props.formSubmitted,
              captchaIdentifier: props.captchaIdentifier },

            _react2.default.createElement('button', { className: styles.submit },
              props.translate('companyPage', 'contactsForm', 'submit'),
              props.formSubmitting && _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })))))));






};

CompanyContactUs.propTypes = {
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  showMessage: _propTypes2.default.func,
  formError: _propTypes2.default.object,
  onSubmit: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  id: _propTypes2.default.string,
  companyName: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  captchaIdentifier: _propTypes2.default.string };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'company-contact-us' })(
CompanyContactUs);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/CompanyContactUs.js
// module id = 2607
// module chunks = 0